// extracted by mini-css-extract-plugin
export default {"arrow":"Tooltip_arrow__NEUeh","open":"Tooltip_open__x0ulM"};